import { render, staticRenderFns } from "./SearchStockItemToAddToPurchaseInvoiceEdit.vue?vue&type=template&id=10676f4e&scoped=true&"
import script from "./SearchStockItemToAddToPurchaseInvoiceEdit.vue?vue&type=script&lang=js&"
export * from "./SearchStockItemToAddToPurchaseInvoiceEdit.vue?vue&type=script&lang=js&"
import style0 from "./SearchStockItemToAddToPurchaseInvoiceEdit.vue?vue&type=style&index=0&id=10676f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10676f4e",
  null
  
)

export default component.exports